import styled, { keyframes } from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  position: relative;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: #62c7cc;
`;

export const MidiaContainer = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
  background-repeat: no-repeat;
  background-size: 600px;
  background-position: center;
  p {
    position: absolute;
    top: 60%;
    text-align: center;
    width: 100%;
    font-size: 3.5rem;
    font-weight: bold;
    color: #fff;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  @media (max-width: 1000px) {
    p {
      top: 70%;
      font-size: 3rem;
    }
  }
`;

export const Video = styled.video`
  height: 100%;
  width: 100%;
  object-fit: contain;
`;

export const BackDrop = styled.div`
  position: absolute;
  inset: 0px;
  background-color: rgb(0, 0, 0, 0.7);
  backdrop-filter: blur(4px);
`;

export const MainChamados = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 20rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgb(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
  background-color: #fff;
`;

export const ContentChamados = styled.div`
  overflow: hidden;
  padding: 1.5rem;
  @media (max-width: 1000px) {
    padding: 0.5rem;
  }
`;

export const TituloChamados = styled.h2`
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  @media (max-width: 1000px) {
    font-size: 1rem;
    margin-bottom: 0;
  }
`;

export const ContainerChamados = styled.div`
  margin-top: calc(0.75rem * calc(1 - 0));
  margin-bottom: calc(0.75rem * 0);
`;

export const ContainerImagem = styled.div`
  width: 100%;
  background-color: #62c7cc;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80px;
  img {
    width: 80%;
    height: auto;
  }
  @media (max-width: 1000px) {
    height: 60px;
    img {
      height: 40px;
    }
  }
`;

export const Card = styled.div`
  border: 1px solid #d3d3d3;
  border-radius: 0.8rem;
  border-left: 4px solid oklch(0.5367 0.1772 28.04);
  padding: 0.6rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgb(0, 0, 0, 0.25);
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 1rem;
  @media (max-width: 1000px) {
    padding: 0.5rem 0.35rem;
    margin-bottom: 0.5rem;
  }
  & :nth-child(1) {
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  & :nth-child(2) {
    fontsize: 0.875rem;
    lineheight: 1.25rem;
    @media (max-width: 1000px) {
      margin-bottom: 0;
    }
  }
`;

export const AtivoMain = styled.div`
  position: absolute;
  inset: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
`;

export const AtivoCard = styled.div`
  width: 100%;
  max-width: 56rem;
  padding: 3rem;
  box-shadow: 0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgb(0, 0, 0, 0.25);
  transition-duration: 500ms;
  background-color: #94f8fd;
  border-width: 4px;
  border-radius: 0.85rem;
  border-color: oklch(0.5367 0.1772 28.04);
  border-style: solid;
  box-sizing: border-box;
  @media (max-width: 1000px) {
    padding: 1rem;
  }
`;

const pulse = keyframes`
  0%, 100% {
    color: hsl(0, 89%, 55%); /* vermelho claro */
  }
  50% {
    color: hsl(0, 95.89041095890413%, 28.627450980392155%); /* vermelho escuro */
  }
`;

export const AtivoHeader = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  animation: ${pulse} 1.5s infinite alternate ease-in-out;
`;

export const AtivoTitulo = styled.div`
  font-size: 3rem;
  line-height: 1;
  font-weight: 700;
`;

export const AtivoContainer = styled.div`
  margin-top: calc(1.5rem * calc(1 - 0));
  margin-bottom: calc(1.5rem * 0);
  text-align: center;
`;

export const AtivoSubtitulo = styled.p`
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 500;
`;

export const AtivoSubtitulo2 = styled.p`
  font-size: 4.5rem;
  line-height: 1;
  font-weight: 700;
  color: oklch(0.5367 0.1772 28.04);
`;

export const AtivoContainerImagem = styled.div`
  display: flex;
  justify-content: right;
  align-items: center;
  height: 1px;
  img {
    width: auto;
    height: 37px;
  }
  @media (max-width: 1000px) {
    height: 1px;
    img {
      height: 37px;
    }
  }
`;
